window.addEventListener('heyflow-screen-view', (event) => {
    // console.log('heyflow screen view:', event.detail);
});

window.addEventListener('heyflow-submit', (event) => {
    // console.log('heyflow submit:', event.detail);
});

// Continue button - target zones 
document.addEventListener('DOMContentLoaded', function() {
  const contBtn = document.getElementById('id-5106a63d');
  if (contBtn) {
    contBtn.style.position  = 'fixed';
    contBtn.style.bottom    = '20px';
    contBtn.style.left      = '50%';
    contBtn.style.transform = 'translateX(-50%)';
    contBtn.style.zIndex    = '9999';
    contBtn.style.width     = 'auto';
    contBtn.style.minWidth  = '120px';
    contBtn.style.padding   = '12px 160px';
  }
});

// Continue button - ingredients id-74a279d0

// Continue button - diet id-72ef161f

// Continue button - bpi 'button-e77df086'

